<template>
  <div class="modal-reset-ques-num-pdf-question">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container-outer">
          <ButtonClose
            class="modal-default-button"
            @click.native="showCheckCloseModal"
          />
          <div
            ref="modalContainer"
            class="modal-container"
          >
            <div class="h-100 w-100 modal-contents-area">
              <div class="d-flex justify-content-around modal-contents-area-inner">
                <!-- 設定 -->
                <div class="modal-contents-area-left">
                  <div class="h-100 p-3 card setting-area">
                    <FormTextField
                      :label-text="$t('labels.taskName')"
                      :initial-value="taskName"
                      :disabled="true"
                      :max-length="50"
                      @input="inputTaskName"
                      @on-blur="blurTaskName"
                    />
                    <div
                      v-if="showMsgTaskName"
                      class="text-danger"
                    >
                      {{ showMsgTaskName }}
                    </div>
                    <div>
                      <br>
                      <div>
                        {{ $t("labels.questionQuantity") }}
                      </div>
                      <div class="question-area">
                        <div class="question-amount mx-3">
                          <div class="row py-1">
                            <div
                              class="col-2 p-0 text-end"
                              @click="questionCount = Math.max(questionCount - 1, 1)"
                            >
                              <i class="icon-minus bi bi-dash-circle-fill" />
                            </div>
                            <div class="col-3 p-0 text-center">
                              {{
                                $t("labels.questionNumber", { number: questionCount })
                              }}
                            </div>
                            <div
                              class="col-2 p-0 text-start"
                              @click="questionCount = Math.min(questionCount + 1, 50)"
                            >
                              <i class="icon-plus bi bi-plus-circle-fill" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br>
                    <FormTextField
                      :label-text="$t('labels.sendMemo')"
                      :initial-value="sendMemo"
                      :disabled="true"
                      :max-length="50"
                      @input="inputSendMemo"
                      @on-blur="blurSendMemo"
                    />
                    <div
                      v-if="showMsgSendMemo"
                      class="text-danger"
                    >
                      {{ showMsgSendMemo }}
                    </div>
                  </div>
                </div>

                <!-- プレビュー -->
                <div class="modal-contents-area-right preview-image-container">
                  <PreviewPdfContainer
                    :img-list="imageList"
                  />
                </div>
              </div>

              <!-- 注釈 -->
              <div class="d-flex justify-content-end mb-2">
                <div
                  class="col-12"
                  style="text-align: right"
                >
                  <div
                    style="font-size: 70%; text-align: left; position: relative; display: inline-block"
                  >
                    {{ $t("labels.recommendPageMessage") }}
                  </div>
                </div>
              </div>

              <!-- アクションボタン -->
              <div class="row gx-5 justify-content-center">
                <div class="col-auto">
                  <ButtonBorderCircleMedium
                    :label-name="$t('buttons.cancel')"
                    :label-color="colorLayoutTheme"
                    :border-color="colorLayoutTheme"
                    @click.native="$emit('close')"
                  />
                </div>
                <div class="col-auto">
                  <!-- 保存処理 -->
                  <ButtonBorderCircleMedium
                    :label-name="$t('buttons.save')"
                    color="layout-theme-light"
                    :label-color="colorLayoutTheme"
                    :border-color="colorLayoutTheme"
                    @click.native="onClickSave"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 閉じるメッセージ用 -->
    <ModalConfirm
      v-if="showCautionCloseMessage"
      :message="$t('messages.confirm.notSavedOriginalFile')"
      v-on="{
        'ok-confirm-modal': onClickOkForCautionCloseMessage,
        'close-confirm-modal': onClickCloseForCautionCloseMessage,
      }"
    />
  </div>
</template>

<script>
/**
 * 宿題管理 - PDFプレビューモーダル
 */
import { db } from "@/dbs/indexedDb"
import ButtonClose from "@/components/atoms/buttons/ButtonClose.vue"
import FormTextField from "@/components/atoms/FormTextField.vue"
import ButtonBorderCircleMedium from "@/components/atoms/buttons/ButtonBorderCircleMedium.vue"
import PreviewPdfContainer from "@/components/organisms/PreviewPdfContainer.vue"
import ModalConfirm from "@/components/organisms/modal/ModalConfirm.vue"

export default {
  name: "ModalResetQuesNumPdfQuestion",
  components: {
    ButtonClose,
    FormTextField,
    ButtonBorderCircleMedium,
    PreviewPdfContainer,
    ModalConfirm,
  },
  props: {
    taskName: {
      type: String,
      require: true,
      default: function () {
        return ""
      },
    },
    sendMemo: {
      type: String,
      require: true,
      default: function () {
        return ""
      },
    },
    imageList: {
      type: Array,
      require: true,
      default: function () {
        return ""
      },
    },
    // ファイルパス
    filePath: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    colorLayoutTheme: "#ff7f27",
    settingList: null, // 設定リスト
    messageDisplayFlg: false, // メッセージ表示フラグ
    modalSendMemo: "", // 送信メモ
    modalTaskName: "", // 課題名
    showMsgTaskName: "", // 課題名エラーメッセージ
    showMsgSendMemo: "", // 送信メモエラーメッセージ
    questionCount: 1,   // 問題数
    showCautionCloseMessage: false,
  }),

  mounted: async function () {
    // リサイズ時にモーダルサイズの調整を行う（iPad対応）
    window.addEventListener('resize', () => {
      this.adjustModal();
    });
    this.adjustModal();

    this.modalTaskName = this.taskName
    this.modalSendMemo = this.sendMemo

    // 初期表示
    if (this.filePath != "") {
      const result = await this.getUploadHomeworkDetailItems(this.filePath)
      if (result !== undefined) {
        this.questionCount = result.uploadHomeworkDetailItem.questionCount
      }
    }
  },

  methods: {
    /**
     * モーダルサイズ調整
     */
    adjustModal() {
      var e = this.$refs.modalContainer;
      if (e) {
        var v = window.innerHeight;
        e.style.height = `${ (v - 20) }px`;
      }
    },

    // 登録処理
    onClickSave: function () {
      if (this.isError()) return
      this.$emit("save", {
        taskName: this.modalTaskName,
        sendMemo: this.modalSendMemo,
        img: this.imageList,
        questionCount: this.questionCount,
      })
    },

    // 課題名入力値取得
    inputTaskName: function (text) {
      this.modalTaskName = text
    },

    // 送信メモ入力値取得
    inputSendMemo: function (text) {
      this.modalSendMemo = text
    },

    // 課題名フォーカスアウト処理
    blurTaskName: function (text) {
      this.showMsgTaskName = ""
      // 課題名必須チェック
      if (text.length > 50) {
        this.showMsgTaskName = this.$t("messages.error.overTextLength", {
          maxLength: "50",
        })
      }
    },

    // 送信メモフォーカスアウト処理
    blurSendMemo: function (text) {
      this.showMsgSendMemo = ""
      // 送信メモ必須チェック
      if (text.length > 50) {
        this.showMsgSendMemo = this.$t("messages.error.overTextLength", {
          maxLength: "50",
        })
      }
    },

    // エラーチェック
    isError: function () {
      let retFlg = false
      if (this.modalTaskName.length <= 0) {
        this.showMsgTaskName = this.$t("messages.error.required")
        retFlg = true
      } else {
        this.blurTaskName(this.modalTaskName)
        this.blurSendMemo(this.modalSendMemo)
        if (this.showMsgTaskName || this.showMsgSendMemo) {
          retFlg = true
        }
      }
      return retFlg
    },
    /**
     * アップロード一覧（IndexedDB）取得
     */
    async getUploadHomeworkDetailItems(filePath) {
      return await db.uploadHomeworkDetailItems.get(filePath)
    },

    /**
     * 閉じるボタン
     */
    showCheckCloseModal() {
      if (!this.isDisabled) {
        this.showCautionCloseMessage = true
      } else {
        this.$emit("close")
      }
    },
    onClickOkForCautionCloseMessage() {
      this.showCautionCloseMessage = false
      this.$emit("close")
    },
    onClickCloseForCautionCloseMessage() {
      this.showCautionCloseMessage = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container-outer {
      width: 100%;
      margin-left: auto;
      margin-right: auto;

      .modal-default-button {
        position: absolute;
        left: calc(100vw - 50px);
      }

      .modal-container {
        position: relative;
        width: calc(100vw - 100px);
        height: calc(100vh - 20px);
        margin: auto;
        padding: 15px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;

        .modal-contents-area {
          display: flex;
          flex-direction: column;

          .modal-contents-area-inner {
            flex-grow: 1;
            min-height: 0;
          }

          .modal-contents-area-left {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 33%;
            padding-right: 30px;
          }

          .modal-contents-area-right {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 67%;
          }
        }
      }
    }
  }
}

.setting-area {
  overflow-y: auto;
}

.preview-image-container {
  height: 100%;
}

.question-area {
  word-wrap: normal;

  .icon-minus:before,
  .icon-plus:before {
    color: #0070c0;

    font-size: 120%;
    vertical-align: bottom;
    cursor: pointer;
  }
}
</style>
